const MENU_QR_TABLE_ID = 'menu'

/** Menu-QR рестораны, на которых футер остаётся видимым */
const MENU_QR_TABLES_WITH_FOOTER = new Set(['redwood-5789', 'iiko2'])

export const isMenuQrTable = (_restaurantCode: string, tableId?: string | null) => {
  if (!tableId) {
    return false
  }

  return String(tableId) === MENU_QR_TABLE_ID
}

export const shouldHideFooterForMenuQrTable = (restaurantCode: string, tableId?: string | null) => {
  if (!isMenuQrTable(restaurantCode, tableId)) {
    return false
  }

  return !MENU_QR_TABLES_WITH_FOOTER.has(restaurantCode)
}
